'use strict';

angular.module('TurneroApp').service('turnosService', ['$resource', 'portal', function ($resource, portal) {
	return $resource(portal.getUrlServer() + 'api/Turno/:id', { id: '@Id_Turno' }, {
		Get_Supervision_Filtro: {
			method: 'GET',
            url: portal.getUrlServer() + 'api/Turno/Get_Supervision_Filtro/:id_centro_atencion/',
            cancellable: true
		},
		Get_Supervision: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Supervision/'
		},
		Get_Anteriores: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Anteriores'
		},
		Get_Anteriores_Hist: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Anteriores_Hist'
		},
		Get_Proximos: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Proximos/'
		},
		Get_Detalle: {
			method: 'GET',
			params: {
				id_turno: '@id_turno'
			},
			url: portal.getUrlServer() + 'api/Turno/Get_Detalle/:id_turno/'
		},
		Get_Estado_Historial: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Estado_Historial/'
		},
		Get_Comentario_Historial: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Comentario_Historial/:id_turno/'
		},
		Get_Reimpresion: {
            method: 'GET',
            params: {
                id_turno: '@id_turno',
                desde_ciudadano: '@desde_ciudadano'
            },
			url: portal.getUrlServer() + 'api/Turno/Get_Reimpresion/'
        },
        Get_Reimpresion_Agente: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Turno/Get_Reimpresion_Agente/:id_turno/'
        },
		Get_PreConfirmacion_Online: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_PreConfirmacion_Online/'
		},
		Get_PreConfirmacion_Asistencia: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_PreConfirmacion_Asistencia/'
		},
		Post_Comentario: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/Post_Comentario/'
		},
		Post_Turno_Online: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/Post_Turno_Online/'
		},
		Post_Turno_Presencial: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/Post_Turno_Presencial/'
		},
		Post_Turno_Telefonico: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/Post_Turno_Telefonico/'
		},
		Post_Turno_Orden_Llegada: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/Post_Turno_Orden_Llegada/'
		},
		Put_Turno_Cancelar: {
			method: 'PUT',
			params: {
				id_turnos: '@id_turnos',
				id_motivo: '@id_motivo'
			},
			url: portal.getUrlServer() + 'api/Turno/Put_Turno_Cancelar/'
		},
		Get_Turnos_Imprimir: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Turnos_Imprimir/'

		},
		Get_turno: function(params) {
			return $resource('/api/turnos/getTurno',{}, {
				get: { method: 'GET', params: params }
			}).get();
		},
		Get_TramitesYAgendas: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_TramitesYAgendas/'

		},
		Get_AgendasXTramite: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_AgendasXTramite/'

		},
		Get_Persona: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Persona/'

		},
		Put_Turno_Anunciar: {
			method: 'PUT',
			params: {
                id_turno: '@id_turno',
                id_centro_atencion: '@id_centro_atencion',
			},
			url: portal.getUrlServer() + 'api/Turno/Put_Turno_Anunciar'

		},
		Get_Turnos_Para_Anunciar: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Turnos_Para_Anunciar/'

		},
		Get_Sobreturno: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Sobreturno/'
        },
		Get_Persona_Con_Turno_Recepcion: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Persona_Con_Turno_Recepcion/'
		},
		Get_Ticket: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Ticket/'
		},
		Put_Turno_Estado: {
			method: 'PUT',
			params: {
				id_turno: '@id_turno',
				id_estado: '@id_estado',
                hacer_commit: '@hacer_commit',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Put_Turno_Estado/'
		},
		Get_Historial_Turnos: {
			method: 'GET',
			params: {
				id_turno: '@id_turno'
			},
			url: portal.getUrlServer() + 'api/Turno/Get_Historial_Turnos/'
		},
		Get_Turnos_Atencion: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Turnos_Atencion/'
        },
        Get_Turnos_Atencion_X_Agenda: {
            method: 'GET',
            params: {
                Id_Agenda: '@Id_Agenda',
                Id_Usuario_Sesion: '@Id_Usuario_Sesion',
                Id_Centro_Usuario: '@Id_Centro_Usuario',
                Traer_solo_asociados_a_usuario: '@Traer_solo_asociados_a_usuario'
            },
            url: portal.getUrlServer() + 'api/Turno/Get_Turnos_Atencion_X_Agenda/'
        },
		Get_Turnos_Mensaje: {
			method: 'GET',
			params: {
				Id_Turno: '@Id_Turno',
				Id_Estado: '@Id_Estado'
			},
			url: portal.getUrlServer() + 'api/Turno/Get_Turnos_Mensaje/'
		},
		Put_Turno_Prioridad_Ley: {
			method: 'PUT',
			params: {
                Id_Turno: '@Id_Turno',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Put_Turno_Prioridad_Ley/'
		},
		Turnos_Cancelar_Atencion: {
			method: 'PUT',
			params: {
                Id_Turno: '@Id_Turno',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Turnos_Cancelar_Atencion/'
		},
		Traer_Tramite_Suac: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Traer_Tramite_Suac/'
		},
		Put_Turno_Tramite_Suac: {
			method: 'PUT',
			params: {
				Id_Turno: '@Id_Turno',
                Id_Tramite_Suac: '@Id_Tramite_Suac',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Put_Turno_Tramite_Suac/'
		},
		Traer_Notificaciones_Agenda_Combo: {
			method: 'GET',
			params: {
				Id_Agenda: '@Id_Agenda',
				Id_Estado_Turno: '@Id_Estado_Turno'
			},
			url: portal.getUrlServer() + 'api/Turno/Traer_Notificaciones_Agenda_Combo/'
		},
		Enviar_Mail_Personalizado: {
			method: 'POST',
			params: {
				Id_Turno: '@Id_Turno',
				Mensaje: '@Mensaje',
				Asunto: '@Asunto'
			},
			url: portal.getUrlServer() + 'api/Turno/Enviar_Mail_Personalizado/'
		},
		Enviar_Notificacion_Mail: {
			method: 'POST',
			params: {
				Id_Turno: '@Id_Turno',
				Id_Notificacion: '@Id_Notificacion'
			},
			url: portal.getUrlServer() + 'api/Turno/Enviar_Notificacion_Mail/'
		},
		Cambiar_Estado_Turno_Anterior: {
			method: 'PUT',
			params: {
				Id_Turno: '@Id_Turno'
			},
			url: portal.getUrlServer() + 'api/Turno/Cambiar_Estado_Turno_Anterior/'
		},
		Pasar_Estado_Final_Supervision: {
			method: 'PUT',
			params: {
				Id_Turno: '@Id_Turno',
				Id_Centro_Usuario: '@Id_Centro_Usuario',
				Id_Estado: '@Id_Estado',
			},
			url: portal.getUrlServer() + 'api/Turno/Pasar_Estado_Final_Supervision'
		},
		Get_Estados_Combo: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Estados_Combo'
		},
		Get_Turno_Imprime_ticket: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/Get_Turno_Imprime_ticket/'
		},
		Get_Id_Turno_Reagendado: {
		    method: 'GET',
		    url: portal.getUrlServer() + 'api/Turno/Get_Id_Turno_Reagendado/'
		},
		Turno_Finalizar_Put: {
			method: 'PUT',
			params: {
                Id_Turno: '@Id_Turno',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Turno_Finalizar_Put/'
		},
		Llamar_Turno: {
			method: 'PUT',
			params: {
                Id_Turno: '@Id_Turno',
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
			},
			url: portal.getUrlServer() + 'api/Turno/Llamar_Turno/'
		},
		Reagendar_Turno_Simple: {
			method: 'PUT',
			params: {
				Id_Turno: '@Id_Turno',
				Id_Motivo: '@Id_Motivo',
				Fec_Turno: '@Fec_Turno',
			},
			url: portal.getUrlServer() + 'api/Turno/Reagendar_Turno_Simple/'
		},
		Reagendar_Turnos_Multiple: {
			method: 'PUT',
			params: {
				Id_Turnos: '@Id_Turnos',
				Id_Motivo: '@Id_Motivo'
			},
			url: portal.getUrlServer() + 'api/Turno/Reagendar_Turnos_Multiple/'
	    },
        ValidarCuilCuit: {
            method: 'GET',
            params: {
                Cuil_Cuit: '@Cuil_Cuit'
            },
            url: portal.getUrlServer() + 'api/Turno/ValidarCuilCuit/'

        },
		CancelarTurnoPorUuid: {
			method: 'PUT',
			params: {
				hash_turno: '@hash_turno'
			},
			url: portal.getUrlServer() + 'api/Turno/cancelarTurnoPorUuid/:hash_turno'
		},
		getCertificado: {
			method: 'GET',
			url: portal.getUrlServer() + 'api/Turno/:id/Traer_Certificado',
		},
		enviarMailCertificado: {
			method: 'POST',
			url: portal.getUrlServer() + 'api/Turno/:id/Enviar_Mail_Certificado',
		},
	});
}]);



// WEBPACK FOOTER //
// ./app/components/turnos/turnosService.js